module.exports = __webpack_public_path__ + "media/images/Up-button-11d498eb95e038b92d95f839d7c87ccf.png";